import styled from "styled-components"

export const Container = styled.div`
    background-color: var(--medGrey);
    color: var(--lightGrey);
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const Wrapper = styled.div`
    width: 300px;
    padding: 20px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    margin-right: 20px;
    background-color: var(--darkGrey);
    border-radius: 10px;
    display: flex;
    justify-content: center;
`

export const StyledForm = styled.form`
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
`

export const StyledInput = styled.input`
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    font-size: var(--fontM);
    border: none;
    border-bottom: 1px solid var(--primary);
    width: 200px;
    height: 30px;

    :focus{
        border-bottom: 1px solid var(--secondary);
        outline: none;
    }
`

export const StyledButton = styled.button`
    width: 200px;
    border: none;
    padding: 5px;
    background-color: var(--primary);
    border-radius: 5px;
    color: var(--white);
    font-size: var(--fontM);
    cursor: pointer;
`

export const Error = styled.p`
    color: var(--secondary);
`